/**
@ngdoc directive
@name multiselect

@description
multiselect checkboxes with search

@usage

*/

(function() {
  'use strict';

var multiselect = function($timeout, $templateCache) {
    return {
        restrict: "EA",
        scope: true,
        bindToController: {
            label: '@',
            fieldName: "@",
            ngModel:"=",
            data:"&",
            ngRequired: "=?",
            maxHeight:'@',
            termsWidget: "@?", // inline multiselect
            formInline: '@'
        },
        controllerAs: 'multiselectCtrl',
        replace: true,
        transclude: false,
        template: $templateCache.get("formWidget/multiselect.html"),
        controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){

            var _this = this;

            _this.$onInit = function(){
                $scope.dotModel = {};

                _this.ngModel   = (_this.ngModel != (undefined || null)) ? _this.ngModel : {};
                _this.maxHeight = angular.isDefined(_this.maxHeight) ? _this.maxHeight : '160';
                _this.formBox   = angular.isDefined(_this.termsWidget) && _this.termsWidget === 'true' ? false : true; // true by default

                // without conversion to Array of objects orderBy wouldn't not be possible in the template
                $scope.dotModel.data = [];
                angular.forEach(_this.data(), function(label, val){
                    $scope.dotModel.data.push({val:val, label:label});
                });
            }

            _this.checkAll = function(){
                angular.forEach(_this.data(), function(label, val){
                    _this.ngModel[val] = true;
                });
            }

        }]
    }
}
multiselect.$inject = ['$timeout', '$templateCache'];
angular.module('app').directive('multiselect', multiselect);

}());

